<template>
	<form autocomplete="on" novalidate @submit.prevent>
		<div class="m-b-2">
			<fieldset class="form-group" :class="{'has-danger' : !formIsValid && formIsDirty}" v-for="(group, groupIndex) in formDefinition" :key="groupIndex">
				<legend class="sr-only">{{ group.groupName }}</legend>
				<div v-for="(field, index) in group.fields" :key="field.fieldName" class="form-group">
					<FormInputText
						:ref="index" v-if="field.type === 'text'"
						:fieldName="field.fieldName"
						:fieldPrompt="field.fieldPrompt"
						:initialValue="field.initialValue"
						:defaultValue="field.defaultValue"
						:required="field.required"
						:maxLength="field.maxlength"
						:autoFocus="field.autofocus"
						:enterTarget="field.enterTarget"
						:formIsDirty="formIsDirty"
						@changed="handleFieldChanged"
						@validate="handleTriggerValidation" />
				</div>
			</fieldset>
		</div>
	</form>
</template>

<script>
import { defineComponent } from 'vue';
import _ from 'lodash';
import FormInputText from '@/components/schreg-common/Forms/FormInputText.vue';

export default defineComponent({
	name: 'Forms',
	components: {
		FormInputText
	},
	props: {
		formDefinition: {
			required: true,
			type: Array
		}
	},
	data() {
		return {
			formIsDirty: false,
			formIsValid: true
		};
	},
	mounted() {
		this.completeMounting();
	},
	destroyed() {

	},
	methods: {
		completeMounting() {
			this.formIsDirty = false;
		},
		validate(customValidation) {
			this.formIsDirty = true;
			let _valid = true;
			Object.keys(this.$refs).forEach(group => {
				Object.keys(this.$refs[group]).forEach(key => {
					let field = _.get(this.$refs[group], key);
					if (field.length) {field = field[0];}
					_valid &= !!field.validate(customValidation);
				});
			});
			this.formIsValid = _valid;
			return _valid;
		},
		resetDirty() {
			this.formIsDirty = false;
		},
		setValue(field, value) {
			Object.keys(this.$refs).forEach(group => {
				Object.keys(this.$refs[group]).forEach(key => {
					let fieldCheck = _.get(this.$refs[group], key);
					if (fieldCheck.length) {fieldCheck = fieldCheck[0];}
					if (fieldCheck.getId() === field) {
						fieldCheck.setValue(value);
					}
				});
			});
		},
		values() {
			let _data = {};
			Object.keys(this.$refs).forEach(group => {
				Object.keys(this.$refs[group]).forEach(key => {
					let field = _.get(this.$refs[group], key);
					if (field.length) {field = field[0];}
					Object.assign(_data, { [field.getId()]: field.getValue() });
				});
			});
			return _data;
		},
		handleTriggerValidation() {
			this.$emit('validate');
		},
		handleFieldChanged(field, value) {
			this.$emit('changed', field, value);
		}
	}
});
</script>
